import { render } from "./PayoutCompensationBody.vue?vue&type=template&id=57b55950&scoped=true&ts=true"
import script from "./PayoutCompensationBody.vue?vue&type=script&lang=ts"
export * from "./PayoutCompensationBody.vue?vue&type=script&lang=ts"

import "./PayoutCompensationBody.vue?vue&type=style&index=0&id=57b55950&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b55950"]])

export default __exports__